<template>
  <div class="CONTENT">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'blueprint-content',
};
</script>

<style lang="scss" scoped>
.CONTENT {
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  width: 100%;
}
</style>
